<template>
  <v-card class="wrapper table-wrapper pa-0 ma-0">
    <iframe
      ref="integratorFrame"
      :src="iframeSrc"
      class="integrator-admin integrator-frame"
      frameborder="0"
      title="AbrIron Integrator Admin"
      allow="clipboard-read; clipboard-write"
      @load="onIframeLoad"
    />
  </v-card>
</template>

<script>
const AUTH_SCRIPT_SRC =
  "https://admin-integrator.abriron.com/abriron-iframe-auth.js";
const AUTH_SCRIPT_ID = "abriron-iframe-auth-script";

function loadAbrironIframeAuth() {
  if (window.AbrironIframeAuth) {
    return Promise.resolve(window.AbrironIframeAuth);
  }

  const existing = document.getElementById(AUTH_SCRIPT_ID);
  if (existing) {
    return new Promise((resolve, reject) => {
      if (window.AbrironIframeAuth) {
        resolve(window.AbrironIframeAuth);
        return;
      }
      existing.addEventListener("load", () => resolve(window.AbrironIframeAuth));
      existing.addEventListener("error", () =>
        reject(new Error("Failed to load AbrironIframeAuth"))
      );
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = AUTH_SCRIPT_ID;
    script.src = AUTH_SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve(window.AbrironIframeAuth);
    script.onerror = () =>
      reject(new Error("Failed to load AbrironIframeAuth"));
    document.head.appendChild(script);
  });
}

export default {
  name: "integrator",
  props: {
    path: {
      type: String,
      required: true, // e.g. 'channels/mixin' or 'clubs/magnet'
    },
  },
  computed: {
    iframeSrc() {
      return `https://admin-integrator.abriron.com/${this.path}`;
    },
  },
  mounted() {
    document.documentElement.classList.add("ai-cfo-no-page-scroll");
    document.body.classList.add("ai-cfo-no-page-scroll");
    this.bindIframeAuth();
  },
  beforeDestroy() {
    document.documentElement.classList.remove("ai-cfo-no-page-scroll");
    document.body.classList.remove("ai-cfo-no-page-scroll");
  },
  methods: {
    async bindIframeAuth() {
      try {
        const auth = await loadAbrironIframeAuth();
        if (!auth) return;
        auth.bindIframes("iframe.integrator-admin");
        this.sendTokenToIframe();
      } catch (e) {
        // ignore script load failures; iframe still loads without auth bridge
      }
    },
    onIframeLoad() {
      this.sendTokenToIframe();
    },
    sendTokenToIframe() {
      const auth = window.AbrironIframeAuth;
      const iframe = this.$refs.integratorFrame;
      if (!auth || !iframe) return;
      auth.sendToIframe(iframe);
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: calc(100vh - 100px);
  width: 100%;
  overflow: hidden;
}
.integrator-frame {
  width: 100%;
  height: 100% !important;
  min-height: 0 !important;
  border: 0;
  display: block;
}
.table-wrapper {
  min-height: 300px;
}
</style>
